export const categories = [
  { id: 'all', name: '全部游戏', slug: 'all', icon: 'ri-gamepad-line', description: '浏览 galagame 平台全部热门游戏，找到属于你的专属乐趣' },
  { id: 'action', name: '动作射击', slug: 'action', icon: 'ri-crosshair-line', description: '紧张刺激的射击对战，考验你的反应速度与精准操作' },
  { id: 'rpg', name: '角色扮演', slug: 'rpg', icon: 'ri-sword-line', description: '沉浸式剧情体验，在宏大的世界中书写你的传奇故事' },
  { id: 'strategy', name: '策略竞技', slug: 'strategy', icon: 'ri-brain-line', description: '运筹帷幄之中，决胜千里之外，用智慧征服战场' },
  { id: 'casual', name: '休闲益智', slug: 'casual', icon: 'ri-lightbulb-line', description: '轻松愉快的休闲游戏，随时随地享受游戏乐趣' },
  { id: 'sports', name: '体育竞速', slug: 'sports', icon: 'ri-speed-line', description: '感受速度与激情，在赛道上尽情驰骋争夺冠军荣耀' },
];